/**
 * CharacterStatisticsPage - Просмотр статистики персонажа (legacy)
 */

import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { ucpService } from "../../api/services/ucpService";

const CharacterStatisticsPage = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [loading, setLoading] = useState(true);
    const [characterInfo, setCharacterInfo] = useState({});
    const [situation1, setSituation1] = useState({});
    const [situation2, setSituation2] = useState({});
    const [notifications, setNotifications] = useState([]);
    const [full, setFull] = useState(-1);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await ucpService.getCharacterInfo(id);
                setCharacterInfo(result || {});
            } catch (err) {
                console.error(err.message);
            } finally {
                setLoading(false);
            }
        };

        const getNotifications = async () => {
            try {
                const result = await ucpService.getNotifications(id);
                setNotifications(result || []);
            } catch (err) {
                console.error(err.message);
            }
        };

        fetchData();
        getNotifications();
    }, [id]);

    useEffect(() => {
        const getSituation1 = async (sitId) => {
            try {
                const result = await ucpService.getRoleSituation(sitId);
                setSituation1(result || {});
            } catch (err) {
                console.error(err.message);
            }
        };

        const getSituation2 = async (sitId) => {
            try {
                const result = await ucpService.getRoleSituation(sitId);
                setSituation2(result || {});
            } catch (err) {
                console.error(err.message);
            }
        };

        if (
            characterInfo &&
            characterInfo.idSituation1 &&
            characterInfo.idSituation2
        ) {
            getSituation1(characterInfo.idSituation1);
            getSituation2(characterInfo.idSituation2);
        }
    }, [characterInfo]);

    if (loading) {
        return (
            <div style={{ color: "white", marginTop: "20vh" }}>Loading...</div>
        );
    }

    const retestLink = "retest?id=" + characterInfo.id;

    let status = "";
    switch (characterInfo.status) {
        case 0:
            status = "На рассмотрении";
            break;
        case 1:
            status = "Одобрен";
            break;
        case 2:
            status = "Отклонен";
            break;
        case 4:
            status = "На ретесте";
            break;
        default:
            status = "Определение...";
            break;
    }

    let gender = "";
    switch (characterInfo.gender) {
        case 1:
            gender = "Человек";
            break;
        case 2:
            gender = "Эльф";
            break;
        case 3:
            gender = "Гном";
            break;
        case 4:
            gender = "Краснолюд";
            break;
        case 5:
            gender = "Низушек";
            break;
        case 6:
            gender = "Нимфа";
            break;
        case 7:
            gender = "Вампир";
            break;
        default:
            gender = "";
    }

    let enGender = "";
    switch (characterInfo.gender) {
        case 1:
            enGender = "human";
            break;
        case 2:
            enGender = "elf";
            break;
        case 4:
            enGender = "dwarf";
            break;
        case 6:
            enGender = "nimf";
            break;
        default:
            enGender = "human";
    }
    const enSex = characterInfo.sex === 0 ? "male" : "female";

    const handleShowDescNotification = (notifId) => {
        if (full !== notifId) {
            setFull(notifId);
        } else {
            setFull(-1);
        }
    };

    return (
        <div className="ucp-two-blocks-container">
            <div>
                <button
                    className="ucp-simple-blur-button ucp-button-back"
                    onClick={() => {
                        window.location.href = "/ucp";
                    }}
                >
                    НАЗАД
                </button>
                <div className="character-body">
                    <img
                        src={
                            "/media/" +
                            enGender +
                            "_" +
                            enSex +
                            "_" +
                            characterInfo.startSkinVariable +
                            ".png"
                        }
                        alt=""
                    />
                    <span>
                        {characterInfo.name?.split(" ")[0].toUpperCase()}
                        <br />
                        {characterInfo.name?.split(" ").length > 1
                            ? characterInfo.name.split(" ")[1].toUpperCase()
                            : ""}
                        <br />
                        {characterInfo.name?.split(" ").length > 2
                            ? characterInfo.name.split(" ")[2].toUpperCase()
                            : ""}
                    </span>
                </div>
            </div>
            <SimpleBar className="ucp-second-container">
                <span className="unbounded-font">УВЕДОМЛЕНИЯ</span>
                {notifications.map((notification, index) => {
                    let desc = "";
                    let content = "";
                    if (
                        notification.content.includes("[") &&
                        notification.content.includes("]")
                    ) {
                        if (notification.content.includes("[/ban]"))
                            desc =
                                "Данное наказание ограничивает игру на сервере на определённое количество дней или навсегда.";
                        if (notification.content.includes("[/unban]"))
                            desc =
                                "Теперь Вы можете продолжить игру без каких-либо ограничений.";
                        if (notification.content.includes("[/unwarn]"))
                            desc =
                                "Теперь Вы можете продолжить игру без каких-либо ограничений.";
                        if (notification.content.includes("[/warn]"))
                            desc =
                                "Будьте осторожны, получение новых предупреждений может привести к блокировке!";
                        if (notification.content.includes("[/ajail]"))
                            desc =
                                "Данное наказание ограничивает игру вашего персонажа на некоторый промежуток времени.";
                        content = notification.content;
                        content = content
                            .replace("[/ajail]", "")
                            .replace("[/ban]", "")
                            .replace("[/unban]", "")
                            .replace("[/warn]", "")
                            .replace("[/unwarn]", "");
                        content = content[1].toLowerCase() + content.slice(2);
                        content = notification.admin_name + " " + content;
                    } else {
                        content = notification.content;
                        desc =
                            "Комментарий от администратора: " +
                            notification.comment;
                        if (content.includes("одобрил")) {
                            desc +=
                                "\n\n\nПриятной игры на Medieval Role Play!";
                        }
                    }

                    if (full === index) {
                        return (
                            <div
                                className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow left-text full-desc"
                                style={{ cursor: "pointer" }}
                                key={index}
                                onClick={() => {
                                    handleShowDescNotification(index);
                                }}
                            >
                                {content} <br />
                                <br />
                                {desc}
                            </div>
                        );
                    } else {
                        return (
                            <div
                                className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow left-text"
                                style={{ cursor: "pointer" }}
                                key={index}
                                onClick={() => {
                                    handleShowDescNotification(index);
                                }}
                            >
                                {content}
                            </div>
                        );
                    }
                })}
                <span className="unbounded-font">СТАТИСТИКА</span>
                <h1>ДАТА РЕГИСТРАЦИИ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.createDate
                        ? characterInfo.createDate.split("T")[0].split("-")[2] +
                          "." +
                          characterInfo.createDate.split("T")[0].split("-")[1] +
                          "." +
                          characterInfo.createDate.split("T")[0].split("-")[0]
                        : ""}
                </div>
                <h1>ID ПЕРСОНАЖА</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.id}
                </div>
                <h1>СТАТУС</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {status.toUpperCase()}
                </div>
                <h1>ПОЛ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.sex === 0 ? "МУЖЧИНА" : "ЖЕНЩИНА"}
                </div>
                <h1>РАСА</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {gender.toUpperCase()}
                </div>
                <h1>ИМЯ ПЕРСОНАЖА</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.name?.replace("_", " ").toUpperCase()}
                </div>
                <h1>КВЕНТА ПЕРСОНАЖА</h1>
                <h1>ПРЕДЫСТОРИЯ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.prehistory}
                </div>
                <h1>ЧЕРТЫ ХАРАКТЕРА</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.traits}
                </div>
                <h1>НАВЫКИ, УВЛЕЧЕНИЯ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.skills}
                </div>
                <h1>ВНЕШНИЕ ПРИМЕТЫ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.appearance}
                </div>

                <h1>РОЛЕВЫЕ СИТУАЦИИ</h1>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {situation1.content}
                </div>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.answerSituation1}
                </div>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {situation2.content}
                </div>
                <div className="ucp-simple-info-block ucp-simple-info-block--yellow-shadow">
                    {characterInfo.answerSituation2}
                </div>

                {characterInfo.status === 4 && (
                    <button
                        className="ucp-simple-yellow-button"
                        onClick={() => {
                            window.location.href = retestLink;
                        }}
                    >
                        ПРОЙТИ РЕТЕСТ
                    </button>
                )}
            </SimpleBar>
        </div>
    );
};

export default CharacterStatisticsPage;
